'use client';

import { Box, StackProps, forwardRef } from '@chakra-ui/react';

export type DesktopContainerProps = StackProps;

export const DesktopContainer = forwardRef<DesktopContainerProps, 'div'>(
  (props, ref) => {
    return (
      <Box
        ref={ref}
        pt={['1rem', '1rem', 0]}
        pb={['2rem', '2rem', 0]}
        w="full"
        maxW={['full', 'full', '20rem']}
        {...props}
      />
    );
  },
);
